'use client';

import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { Dispatch, memo, SetStateAction, useEffect, useRef } from 'react';

import styles from './styles.module.scss';

const DELAY = 0.2;

interface AnimationProps {
  animation: unknown;
  onComplete?: Dispatch<SetStateAction<boolean>>;
  loop?: boolean;
  isActive?: boolean;
  isList?: boolean;
  duration?: number;
  play?: boolean;
  className?: string;
}

const AnimationContainer = ({
  animation,
  onComplete,
  loop = true,
  isActive = false,
  isList = false,
  duration = 10,
  play,
  className = '',
}: AnimationProps) => {
  const anim = useRef<LottieRefCurrentProps | null>(null);

  const handleComplete = () => {
    if (onComplete) {
      onComplete(false);
    }
  };

  useEffect(() => {
    if (isList && anim.current && duration) {
      const animationDuration = anim.current.getDuration();
      const playbackSpeed = animationDuration! / duration - DELAY;
      anim.current.setSpeed(playbackSpeed);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isActive && anim.current && play) {
      anim.current.stop();
      anim.current.goToAndPlay(0);
    } else if (!isActive && anim.current) {
      const stopAnimation = setTimeout(() => {
        anim.current?.stop();
      }, 1000);

      return () => {
        clearTimeout(stopAnimation);
      };
    }
  }, [isActive, isList, play]);

  return (
    <Lottie
      animationData={animation}
      className={`${styles.animationContainer} ${className}`}
      lottieRef={anim}
      loop={loop}
      onComplete={handleComplete}
    />
  );
};

export default memo(AnimationContainer);
